export default __webpack_public_path__ + "static/media/news37.b64884b0.jpg";